/**
 * 打开文档性能上报点位（按需上报）
 */
export var LoadPerformancePoint;
(function (LoadPerformancePoint) {
    /**
     * 开始解析html
     */
    LoadPerformancePoint["PARSE_HTML"] = "parse_html";
    /**
     * 开始初始化本地编辑相关逻辑
     */
    LoadPerformancePoint["INIT_LOCAL_EDIT"] = "init_local_edit";
    /**
     * 引擎初始化结束
     */
    LoadPerformancePoint["ENGINE_INSTALLED"] = "engine_installed";
    /**
     * 首次数据返回 (无分片请求则等同于全量数据返回)
     */
    LoadPerformancePoint["FIRST_CHUNK_FETCHED"] = "first_chunk_fetched";
    /**
     * 全量数据返回
     */
    LoadPerformancePoint["ALL_CHUNKS_FETCHED"] = "all_chunks_fetched";
    /**
     * 文档首屏可见
     */
    LoadPerformancePoint["CAN_VIEW"] = "can_view";
    /**
     * 文档可交互(例如可滑动)
     */
    LoadPerformancePoint["CAN_INTERACT"] = "can_interact";
    /**
     * 文档可编辑
     */
    LoadPerformancePoint["CAN_EDIT"] = "can_edit";
})(LoadPerformancePoint || (LoadPerformancePoint = {}));
/**
 * 保存文档性能上报点位
 */
export var DumpPerformancePoint;
(function (DumpPerformancePoint) {
    /**
     * 开始保存
     */
    DumpPerformancePoint["BEGIN_DUMP"] = "begin_dump";
    /**
     * 保存结束
     */
    DumpPerformancePoint["FINISH_DUMP"] = "finish_dump";
})(DumpPerformancePoint || (DumpPerformancePoint = {}));
//# sourceMappingURL=mage-report-service.protocol.js.map